<style type="text/scss" lang="scss">
  @import '../../styles/vars';

  textarea {
    appearance: none;
    width: 100%;
    background: #f7f7f8;
    border: none;
    box-shadow: none;
    border-radius: 4px;
    font-family: proxima-nova, sans-serif;
    font-weight: 500;
    color: #4c4c4b;
    font-size: 16px;
    padding: 12px 8px;
    min-height: 360px;

    &:focus {
      outline: none;
      border: none;
      box-shadow: none;
      background-color: darken(#f7f7f8, 2);
    }
  }

  .input-richtext :global(.redactor-box) {
    min-height: 360px;
  }

  .input-richtext :global(.redactor-box.redactor-styles-on) {
    background: #f7f7f8;
    border: none;
  }

  .input-richtext :global(.redactor-air a) {
    box-shadow: 0 2px 2px 0 rgba(23, 28, 33, 0.06);
    border-radius: 4px;
  }


  .input-richtext :global(.redactor-toolbar a) {
    box-shadow: 0 2px 2px 0 rgba(23, 28, 33, 0.06);
    border-radius: 4px;
  }

  .input-richtext :global(.redactor-styles a) {
    color: #ff6452;
  }

  .input-richtext :global(.redactor-styles) {
    font-family: proxima-nova, sans-serif;
    color: #4c4c4b;
  }
</style>

<script>
  import { onMount, afterUpdate } from 'svelte';
  export let value = '';
  export let placeholder = '';
  export let label = '';
  export let disabled = false;

  let textarea;

  function replaceTags(value) {
    /*return value
      .split('{{{')
      .join(`<span data-redactor-type="variable">{{{`)
      .split('}}}')
      .join('}}}</span>');*/
    return value;
  }

  value = value ? replaceTags(value) : value;

  onMount(() => {
    window.$R(textarea, {
      plugins: ['variable'],
      variables: [
        '{{{program.name}}}',
        '{{{program.addressLineOne}}}',
        '{{{program.addressLineTwo}}}',
        '{{{program.city}}}',
        '{{{program.state}}}',
        '{{{program.postal}}}',
        '{{{where}}}',
        '{{{when}}}',
        '{{{person.firstName}}}',
        '{{{person.lastName}}}',
        '{{{coordinator.firstName}}}',
        '{{{coordinator.lastName}}}',
        '{{{coordinator.email}}}',
        '{{{coordinator.phone}}}',
        '{{{leader.firstName}}}',
        '{{{leader.lastName}}}',
        '{{{leader.email}}}',
        '{{{leader.phone}}}'
      ],
      callbacks: {
        changed: function(html) {
          value = html;
        }
      }
    });

    if (disabled) {
      window.$R(textarea, 'module.editor.disable');
    }
  });

  afterUpdate(() => {
    if (!disabled) {
      window.$R(textarea, 'module.editor.enable');
    } else {
      window.$R(textarea, 'module.editor.disable');
    }
  });
</script>

<div class="input-richtext">
  {#if label}<label>{label}</label>{/if}
  <textarea
    readonly="{disabled}"
    bind:this="{textarea}"
    placeholder="{placeholder}"
    value="{value}"
  ></textarea>
</div>
